import React from 'react';
import { Link } from 'react-router-dom';
import { FaLeaf, FaHandsHelping, FaUsers, FaTruck, FaSeedling, FaGlobeAsia } from 'react-icons/fa';
import { GiTomato, GiCarrot, GiCabbage } from 'react-icons/gi';

const AboutPage = () => {

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-green-700 to-green-800 text-white py-24">
        <div className="absolute inset-0 overflow-hidden">
          <img src="/about-hero.jpg" alt="Fresh vegetables" className="w-full h-full object-cover opacity-20" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fadeInDown">About </h1>
        
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-green-600 to-green-400 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-500"></div>
              <img
                src=" https://tse1.mm.bing.net/th/id/OIP.jmXh1cSrM8v5wMOVhS3vaQHaEo?rs=1&pid=ImgDetMain&o=7&rm=3 "
                alt="Our farm partners"
                className="relative w-full h-auto rounded-lg shadow-2xl transform group-hover:scale-105 transition duration-500"
              />
            </div>
            <div className="space-y-6 animate-fadeInUp">
              <h2 className="text-4xl font-bold text-green-800 mb-4">Our Story</h2>
              <p className="text-gray-600 text-lg leading-relaxed">
FreshHarvest Produce was founded with one clear purpose: to deliver farm-fresh, premium-quality vegetables that make everyday meals healthier and more delicious. What began as a modest, family-led initiative has evolved into a reliable name for retailers, distributors, and food businesses across India and international markets              </p>
              <p className="text-gray-600 text-lg leading-relaxed">
                We work directly with over 50 farms in 18 countries, ensuring that every vegetable is grown with care, harvested at peak ripeness, and delivered with speed. Our commitment to sustainability and fair trade practices means you can feel good about every purchase.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition duration-300">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <FaLeaf className="text-3xl text-green-600" />
              </div>
              <h3 className="text-2xl font-bold text-green-700 mb-4">Our Mission</h3>
              <p className="text-gray-600 leading-relaxed">
                To provide the freshest, highest-quality vegetables while promoting sustainable farming practices and supporting local communities. We believe that healthy food should be accessible to everyone.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition duration-300">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <FaHandsHelping className="text-3xl text-green-600" />
              </div>
              <h3 className="text-2xl font-bold text-green-700 mb-4">Our Vision</h3>
              <p className="text-gray-600 leading-relaxed">
                To become a global leader in sustainable vegetable distribution, creating a world where every meal is made with fresh, ethically sourced produce, and where farming communities thrive.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;